import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const HOME = { admin: "/admin", collector: "/dashboard/collector", company: "/dashboard/company", customer: "/dashboard/customer" };

// Role-aware entry point (used by the installed app's "My dashboard" shortcut).
export default function DashboardRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="container-x py-20 text-[#5C6B64]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: "/dashboard" }} />;
  return <Navigate to={HOME[user.role] || "/"} replace />;
}
